import { render } from "./PatientsDatatableTDNotificationStatus.vue?vue&type=template&id=6067d73a"
import script from "./PatientsDatatableTDNotificationStatus.vue?vue&type=script&lang=js"
export * from "./PatientsDatatableTDNotificationStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__